export enum NOTIFICATION_TYPES {
  WARNING = "warning",
  ERROR = "error",
  INFO = "info",
  SUCCESS = "success",
}
